import axios from '../../config/axios.js'

const STATE = {

    guests: [],

}

const GETTERS = {

    guests: state => state.guests,

}

const MUTATIONS = {

    getGuests(state, guests) {
        state.guests = guests
    },

}

const ACTIONS = {

    async inviteGuests({ dispatch }, payload) {
        await axios.ACCESS.post('/api/s2/project/' + payload.proj_id + '/guests', {
                guests: payload.guests,
                message: payload.message,
            })
            .then(res => {
                // console.log('invite/inviteGuests', res)
                if (res.data.result) {
                    dispatch('getGuests', payload.proj_id)
                } else { throw new Error(res.data) }
            })
    },

    async getGuests({ commit }, proj_id) {
        await axios.ACCESS.get('/api/s2/project/' + proj_id + '/guests')
            .then(res => {
                // console.log('invite/getGuests', res)
                if (res.data.result) {
                    commit('getGuests', res.data.guests)
                } else { throw new Error(res.data) }
            })
    },

    async cancelInvitingGuests({ dispatch }, payload) {
        await axios.ACCESS.put('/api/s2/project/' + payload.proj_id + '/guests', {
                guests: payload.guests
            })
            .then(res => {
                // console.log('invite/cancelInvitingGuests', res)
                if (res.data.result) {
                    dispatch('getGuests', payload.proj_id)
                } else { throw new Error(res.data) }
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/invite.js